<template>
    <div>
        <div name="table-list" class="table-layout" v-if="paramMap != null">
            <swb-easy-report-table ref="report_table" :confKey="confKey" :configAuto="configAuto" :reportName="reportName" :reportCode="reportCode" :paramMap="paramMap" :paramKeys="paramKeys" :hideParamKeys="hideParamKeys" :showStatColumns="false" :queryData="queryData" :domHeight="domHeight" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :showExport="false" :multiSelect="multiSelect"></swb-easy-report-table>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import easyReportApi from '../../api/easyReport'

    import SwbEasyReport from './EasyReport'
    Vue.regist(SwbEasyReport);

    export default {
        name: 'swb-servc-work-voucher-ds-assign-engineer-select',
        desc: '工单指派调度策略【指派工程师】',
        props: ['shopId', 'voucherId', 'buyerShopId', 'servcId', 'servcType', 'ssuId'],
        data: function () {
            return {
                confKey: 'swb-servc-work-voucher-ds-assign-engineer-select',
                configAuto: true,
                reportCode: "servc_work_voucher_dispatch_strategy_assign_engineer",
                reportName: "工单指派调度策略【指派工程师】",
                domHeight: 550,
                btnColName: null,//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                //
                paramMap: null,
                paramKeys: [],
                hideParamKeys: ["servicerId", "cxtMerchantId", "cxtMerchantIdX", "shopId"],
                queryData: true,
                multiSelect: true
            }
        },
        created: function () {
            let paramMap = {
                shopId: this.shopId
            };
            let hideParamKeys = this.hideParamKeys;
            if(Utils.isNoB(this.voucherId)) {
                this.reportCode = "servc_work_voucher_dispatch_strategy_assign_engineer2";
                paramMap.buyerShopId = this.buyerShopId;
                paramMap.servcId = this.servcId;
                paramMap.servcType = this.servcType;
                paramMap.ssuId = this.ssuId;
                hideParamKeys.push('buyerShopId');
                hideParamKeys.push('servcId');
                hideParamKeys.push('servcType');
                hideParamKeys.push('ssuId');
            } else {
                paramMap.voucherId = this.voucherId;
                hideParamKeys.push('voucherId');
            }
            this.hideParamKeys = Utils.merge([], hideParamKeys);
            this.paramMap = Utils.merge({}, paramMap);
        },
        methods: {
            getTableSelection(){
                return this.$refs.report_table.getTableSelection();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/easyReport/ServcWorkVoucherDsAssignEngineerSelect.vue